import React, { useState } from 'react';
import { Icon, Loader, Popup } from 'semantic-ui-react';
import circleInfo from '../../semantic-ui/site/assets/circle-info.svg';
import { getDecoratedNotificationDetails, formatSchedule } from '../../helpers/notificationsUtils';
import { useDispatch } from 'react-redux';
import { removeUserNotification } from '../../actions/users';
import { history } from '../../store/configureStore';

const NotificationCard = ({ data, onRemoveNotification }) => {
    const dispatcher = useDispatch();
    const [deleting, setDeleting] = useState(false);
    const details = getDecoratedNotificationDetails(data);
    const onDelete = async () => {
        setDeleting(true);
        const response = await dispatcher(removeUserNotification(details.id));
        if (response?.status === 200) {
            setDeleting(false);
            onRemoveNotification(details.id);
        }
    };

    const onTicketRefClick = (ticket) => {
        history.push(`/maintenance/ticketing?textSearch=${ticket}`);
        window.location.reload();
    };

    const renderTicket = (ticket) => {
        if (ticket) {
            return (
                <span>
                    {' '}
                    -{' '}
                    <span className="ticket" onClick={() => onTicketRefClick(ticket)}>
                        {ticket}
                    </span>
                </span>
            );
        }
        return null;
    };

    const renderPopup = (description) => {
        if (description) {
            return <Popup trigger={<img src={circleInfo} className="info-icon" />} content={description} position="bottom right" size="small" />;
        }
        return null;
    };

    const renderCard = () => {
        if (data?.id) {
            return (
                <div className="card-container">
                    <div className={`card ${details?.alertType}`}>
                        <div className="card-content">
                            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                <div>
                                    <div className="title">
                                        {details.title}
                                        {renderTicket(details.ticket)}
                                        {renderPopup(details.description)}
                                    </div>
                                    <div className="footer">{`${formatSchedule(details.start, details.end)}`}</div>
                                </div>
                                <div className="delete-icon">
                                    {deleting ? (
                                        <Loader size="small" inline active />
                                    ) : (
                                        <Icon className="close" style={{ color: '#000' }} size="massive" onClick={onDelete} />
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            );
        }
        return null;
    };

    return renderCard();
};

export default NotificationCard;
